import actions from "./actions";

const initState = {
    tableLoading: false,
    getMsisdnPoolError: null,
    getMsisdnPoolResult: [],
    shortCodeData: [],
    buttonLoading: false,

    msisdnFormModal: false,
    msisdnPoolMessage: null,
    msisdnPoolError: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {

        case actions.GET_MSISDN_POOL_DATA:
            return {
                ...state,
                tableLoading: true,
                buttonLoading: true,
                getMsisdnPoolError: null,
                getMsisdnPoolResult: [],
            };
        case actions.GET_MSISDN_POOL_DATA_SUCCESS:
            return {
                ...state,
                tableLoading: false,
                buttonLoading: false,
                getMsisdnPoolError: null,
                getMsisdnPoolResult: action.result,
            };
        case actions.GET_MSISDN_POOL_DATA_FAILED:
            return {
                ...state,
                tableLoading: false,
                buttonLoading: false,
                getMsisdnPoolError: action.error,
                getMsisdnPoolResult: [],
            };

        case actions.RESET_SEARCH_DATA:
            return {
                ...state,
                loading: false,
                getMsisdnPoolError: null,
                getMsisdnPoolResult: [],
            };

        case actions.GET_SHORT_CODE_DATA:
            return {
                ...state,
            };
        case actions.GET_SHORT_CODE_DATA_SUCCESS:
            return {
                ...state,
                shortCodeData: action.shortCodeData
            };
        case actions.GET_SHORT_CODE__DATA_FAILED:
            return {
                ...state,
                error: action.error
            };

        case actions.PREPARE_MSISDN_FORM:
            return {
                ...state,
                buttonLoading: false,
                msisdnFormModal: true
            };

        case actions.RESET_MSISDN:
            return {
                ...state,
                buttonLoading: false,
                msisdnFormModal: false,
                msisdnPoolError: null,
                msisdnPoolMessage: null,

            };

        case actions.REMOVE_MSISDN_FROM_POOL:
            return {
                ...state,
                buttonLoading: true,
                msisdnFormModal: false,
                msisdnPoolMessage: null,
                msisdnPoolError: null,
            };
        case actions.REMOVE_MSISDN_FROM_POOL_SUCCESS:
            return {
                ...state,
                buttonLoading: false,
                msisdnFormModal: false,
                msisdnPoolMessage: action.message,
                msisdnPoolError: null,
            };
        case actions.REMOVE_MSISDN_FROM_POOL_FAILED:
            return {
                ...state,
                buttonLoading: false,
                msisdnFormModal: true,
                msisdnPoolMessage: null,
                msisdnPoolError: action.error,
            };

        default:
            return state;
    }
}